import { Theme } from './theme.type'

export const defaultTheme: Theme = {
  colors: {
    background: '#070813',
    primary: '#08EDDC',
    primary_1: '#10D1C4',
    primary_2: '#086E6C',
    primary_3: '#1B3E51',
    primary_4: '#0ABAAD',
    primary_5: '#10BBB8',
    white: '#FFFFFF',
    lightgray: '#8D8D8D',
    gray: '#444545',
    darkgray: '#202328',
    black: '#070813',
    green: '#0CAA41',
    red: '#9C291A',
    darkOpacity: '#07081372',
  },
  shadow: {
    shadow_0:
      '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    shadow_1:
      '0px 4px 4px rgba(50, 50, 71, 0.08), 0px 4px 8px rgba(50, 50, 71, 0.06)',
    shadow_2:
      '0px 8px 8px rgba(50, 50, 71, 0.08), 0px 8px 16px rgba(50, 50, 71, 0.06)',
    shadow_3:
      '0px 12px 12px rgba(50, 50, 71, 0.08), 0px 16px 24px rgba(50, 50, 71, 0.08)',
    shadow_4:
      '0px 16px 16px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.16)',
  },
  glow: {
    primary: '0px 0px 10px #08EDDC',
  },
  gradient: {
    primary: 'radial-gradient(100% 50% at 50% 50%, #08eddc 30%, #000000 100%)',
  },
  fontWeights: {
    light: '400',
    regular: '500',
    semibold: '600',
    bold: '700',
  },
  fontSizes: {
    quality: '88px',
    h1: '104px',
    h2: '76px',
    h3: '48px',
    h4: '32px',
    h5: '24px',
    b1: '24px',
    b2: '20px',
    b3: '16px',
    b4: '12px',
  },
  lineHeight: {
    quality: '114px',
    h1: '114px',
    h2: '114px',
    h3: '72px',
    h4: '48px',
    h5: '36px',
    b1: '36px',
    b2: '30px',
    b3: '24px',
    b4: '18px',
  },
  fontFamily: {
    primary: 'Montserrat',
    secondary: 'Numans',
  },
}
